import { createSelector } from 'reselect';
import { getAccessToOthersDepartments } from './access';

const getCurrentUserId = (state) => state?.cmContext?.userId;

export const getAllUsers = (state) => state?.cmUserList?.userList || [];

export const getCurrentUser = createSelector(
  getCurrentUserId,
  getAllUsers,
  (currentUserId, userList) => {
    const current = userList.find((item) => item.user.id === currentUserId);
    return current?.user;
  }
);

export const getCurrentUserDepartmentIds = createSelector(
  getCurrentUserId,
  getAllUsers,
  (currentUserId, userList) => {
    const current = userList.find((item) => item.user.id === currentUserId);
    return (current?.departments || []).map(({ id }) => id);
  }
);

export const getUsersInDepartments = createSelector(
  getAllUsers,
  getCurrentUserDepartmentIds,
  getAccessToOthersDepartments,
  (allUsers, currentUserDepartmentIds, hasAccess) =>
    hasAccess
      ? allUsers
      : allUsers.filter(({ departments }) =>
          departments.some(({ id }) => currentUserDepartmentIds.includes(id))
        )
);
